// extracted by mini-css-extract-plugin
module.exports = {"orderHandle":"styles_orderHandle__3qxde"};